<template>
    <div class="contain" style="padding: 2.25rem 5vw">
        <div style="font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e">家長資料 <span style="white-space: nowrap">Parent Information</span></div>
        <div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem">
            <span style="width: 1rem; height: 1rem; background: #b62d2e; border-radius: 50%; margin-right: 1rem"></span>
            <span style="width: 1rem; height: 1rem; background: #de5934; border-radius: 50%; margin-right: 1rem"></span>
            <span style="width: 1rem; height: 1rem; background: #f1aa55; border-radius: 50%; margin-right: 1rem"></span>
        </div>
        <div class="cart-box">
            <el-form ref="form" :model="form" :rules="rules">
                <el-row type="flex" :gutter="20" style="flex-wrap: wrap">
                    <el-col :xs="24" :sm="24" :lg="8">
                        <el-form-item prop="email">
                            <div class="input-title">電郵地址 Email*</div>
                            <el-input v-model="form.email" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :lg="8">
                        <el-form-item prop="name">
                            <div class="input-title">姓名 Name*</div>
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :lg="8">
                        <el-form-item prop="phone">
                            <div class="input-title">電話 Tel</div>
                            <div class="input-phone">
                                <el-select v-model="form.areaCode" :placeholder="$t('other.pleaseSelect')" allow-create filterable @blur.native.capture="selectBlur($event, 0)">
                                    <el-option v-for="(item, index) in areaCodeData" :key="index" :label="item.label" :value="item.value"> </el-option>
                                </el-select>
                                <el-input v-model="form.phone"></el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <div class="input-title">
                            住址 Address
                            <span style="font-weight: 400">(郵寄地址 Mailing Address)</span>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item prop="country">
                            <div class="input-title">國家 Country/地區 Area</div>
                            <!-- <el-input v-model="form.country"></el-input> -->
                            <el-select v-model="form.country" :placeholder="$t('other.pleaseSelect')" allow-create filterable @blur.native.capture="selectBlur($event, 1)" style="width: 100%">
                                <el-option v-for="(item, index) in countryData" :key="index" :label="item.label" :value="item.value" @click.native.passive="countrySelect(index)"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :xs="24" :sm="8">
                        <el-form-item prop="area">
                            <div class="input-title">區域 Region</div>
                            <el-select v-model="form.area" :placeholder="$t('other.pleaseSelect')" allow-create filterable @blur.native.capture="selectBlur($event, 2)" style="width: 100%">
                                <el-option v-for="(item, index) in areaData" :key="index" :label="item.label" :value="item.value" @click.native.passive="areaSelect(index)"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item prop="district">
                            <div class="input-title">地區 District</div>
                            <el-select v-model="form.district" :placeholder="$t('other.pleaseSelect')" allow-create filterable @blur.native.capture="selectBlur($event, 3)" style="width: 100%">
                                <el-option v-for="(item, index) in districtData" :key="index" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col>
                        <el-form-item prop="address">
                            <div class="input-title">地址 Address</div>
                            <el-input v-model="form.address"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <div class="input-title">重設密碼 Reset Password</div>
                    </el-col>
                    <el-col>
                        <el-form-item prop="password">
                            <div class="input-title">輸入新密碼 New Password</div>
                            <el-input v-model="form.password" :class="showPassword1 ? '' : 'password-hidden'">
                                <i v-show="form.password" class="el-icon-view el-input__icon" slot="suffix" @click="showPassword1 = !showPassword1"> </i>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item prop="confirmPassword">
                            <div class="input-title">重新輸入新密碼 Confirm Password</div>
                            <el-input v-model="form.confirmPassword" :class="showPassword2 ? '' : 'password-hidden'">
                                <i v-show="form.confirmPassword" class="el-icon-view el-input__icon" slot="suffix" @click="showPassword2 = !showPassword2"> </i>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-button round @click="putProfile" class="security-button" style="margin: 2.375rem 0 0">更新 Update</el-button>
        </div>
    </div>
</template>

<script>
// import cities from 'cities.json';
import { putProfile } from "@/api/user";
import { address, areaCode } from "@/biz/static-data";
import { setUserInfo } from "@/utils/auth";
export default {
    props: {
        detail: {
            type: Object,
            default: function () {},
        },
    },
    data() {
        var validatePassword2 = (rule, value, callback) => {
            if (value !== this.form.password && this.form.password) {
                callback(new Error("兩次輸入密碼不一致！The passwords are not the same!"));
            } else {
                callback();
            }
        };
        var validatePassword = (rule, value, callback) => {
            if (/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[`~!@#$^\-&*()=|{}':;',\\[\].<>/?~！@#￥……&*（）——|{}【】'；：""'。，、？]).{8,16}$/.test(value) || !value) {
                callback();
            } else {
                callback(
                    new Error(
                        "您的密碼必須介於 8-16 個字元之間，並且至少包含 1 個大寫字母 1 個小寫字母 1 個數字和 1 個特殊字符。\nYour password must be between 8-16 characters long, and must contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character."
                    )
                );
            }
        };
        return {
            form: {
                email: null,
                name: null,
                areaCode: null,
                phone: null,
                country: null,
                area: null,
                district: null,
                address: null,
                password: null,
                confirmPassword: null,
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "請輸入姓名 Please enter name",
                        trigger: "blur",
                    },
                ],
                password: [{ validator: validatePassword, trigger: "blur" }],
                confirmPassword: [{ validator: validatePassword2, trigger: "blur" }],
            },
            areaCodeData: [],
            countryData: [],
            areaData: [],
            districtData: [],
            showPassword1: false, //是否显示密码
            showPassword2: false, //是否显示密码
        };
    },
    watch: {
        "$store.getters.language": {
            handler() {
                //  this.getCarts()
                this.$nextTick(() => {
                    this.countryData = address;
                });
                this.$forceUpdate();
            },
            deep: true,
        },
        detail() {
            this.initial();
        },
    },
    created() {
        this.initial();
    },
    mounted() {
        this.areaCodeData = areaCode;
        this.countryData = address;
        //解决el-select在IOS移动端上搜索功能不能弹出软键盘的问题
        Array.from(document.getElementsByClassName("el-select")).forEach((item) => {
            item.children[0].children[0].removeAttribute("readOnly");
            item.children[0].children[0].onblur = function () {
                let _this = this;
                setTimeout(() => {
                    _this.removeAttribute("readOnly");
                }, 200);
            };
        });
    },
    methods: {
        initial() {
            this.form = JSON.parse(JSON.stringify(this.detail));
            this.form.password = "";
            if (this.form.firstLogin == 0) {
                this.showTip();
            }
        },
        selectBlur(e, i) {
            if (e.target.value) {
                switch (i) {
                    case 0:
                        this.form.areaCode = e.target.value;
                        break;
                    case 1:
                        this.form.country = e.target.value;
                        break;
                    case 2:
                        this.form.area = e.target.value;
                        break;
                    case 3:
                        this.form.district = e.target.value;
                        break;
                    default:
                        break;
                }
            }
        },
        countrySelect(i) {
            this.areaData = this.countryData[i].children;
            this.districtData = [];
            this.form.area = null;
            this.form.district = null;
        },
        areaSelect(i) {
            this.districtData = this.areaData[i].children;
            this.form.district = null;
        },
        update() {
            this.$emit("getProfile");
            this.$forceUpdate();
        },
        preProcess(newData, oldData) {
            let obj = newData;
            Object.keys(obj).forEach((item) => {
                if (typeof obj[item] === "undefined" || obj[item] === null || obj[item] === "") {
                    if (item == "password") obj[item] = oldData[item];
                }
            });
            return obj;
        },
        putProfile() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let form = this.preProcess(this.form, this.detail);
                    putProfile(form).then(() => {
                        delete this.form.confirmPassword;
                        setUserInfo("userProfile", form);
                        this.$message({
                            message: "更新成功",
                            type: "success",
                        });
                        this.update();
                    });
                }
            });
        },
        showTip() {
            let form = this.preProcess(this.form, this.detail);
            form.firstLogin = 1;
            putProfile(form).then(() => {
                delete this.form.confirmPassword;
                setUserInfo("userProfile", form);
                this.update();
            });
            this.$confirm("請重新為您的帳號設定新密碼。\nPlease reset your account password.", "溫馨提示 Remind", {
                confirmButtonText: "確定 Confirm",
                center: true,
                showClose: false,
                showCancelButton: false,
                closeOnClickModal: false,
                customClass: "exit-box",
                confirmButtonClass: "exit-confirm",
            })
                .then(() => {})
                .catch(() => {});
        },
    },
};
</script>

<style lang="scss" scoped>
.contain {
    //width: 100%;
    display: flex;
    flex-direction: column;
}
.cart-box {
    padding: 1.25rem 0;
}
.input-title {
    color: #8e8e8e;
    font-weight: bold;
    line-height: 1.6rem;
}
.security-button {
    margin: 1.25rem 0;
    border: 0.0625rem solid #fcc03a;
    font-weight: bold;
    font-size: 1.125rem;
    color: #444444;
    background-color: #fcc03a;
}
.el-col {
    padding: 0.625rem;
}

@media (min-width: $minWidth) and (max-width: $maxWidth) {
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .contain {
        height: 100%;
    }
}
::v-deep {
    .el-select .el-input .el-select__caret {
        color: #444444;
    }
    .el-input__inner {
        //border-top-right-radius: 3.125rem;
        //border-bottom-right-radius: 3.125rem;
        border-radius: 0.625rem;
        //background-color: #fffbed;
        border: 0.0625rem solid #a1a1a1;
        padding-left: 0.5rem;
        height: 2.75rem;
        line-height: 2.75rem;
    }
    .input-phone {
        display: flex;
        .el-select .el-input__inner {
            background-color: #ffffff;
            border-radius: 0.625rem;
            width: 5.5rem;
            border: 0.0625rem solid #a1a1a1;
            margin-right: 0.5rem;
        }
    }
    .el-input.is-disabled .el-input__inner {
        background-color: #eeeeee;
        border: 0.0625rem solid #a1a1a1;
    }
    .el-form-item {
        margin-bottom: 0;
    }
    .el-form-item.is-error {
        .el-input__inner {
            border-color: #f1aa55;
        }
        .el-form-item__error {
            color: #8e8e8e;
        }
    }
    .el-form-item__error {
        font-size: 14px;
        line-height: 1.6;
        padding-top: 0;
        position: relative;
    }
    .el-input__icon {
        width: 1.75rem;
        line-height: 2.75rem;
    }
    .el-icon-view {
        vertical-align: top;
    }
    .el-button + .el-button {
        margin: 0;
        margin-top: 1.125rem;
    }
    .el-divider--horizontal {
        margin: 0.5rem 0;
    }
}
</style>